<template>
  <div id="login" class="hello bg-light">
    <div id="login_wrapper"> 
      <b-container id="hero" class="margin-auto rounded">
        <b-row>
          <b-col sm="12" lg="6" class="logo-col hero-col">
            <div id="art" class="qds-logo">
              <a href="#">
                <img src="static/logo.png" class="img-fluid">
              </a>
            </div>
          </b-col>
          
          <b-col sm="12" lg="6" class="bg-green ctl center hero-col">
            <div id="the_form" class="">
              <h1 style="margin-bottom:2rem">Faculty Login</h1>
              <b-form @submit="onSubmit">
                <b-form-group id="exampleInputGroup1"
                    label=""
                    label-for="exampleInput1"
                    description="">
                  <b-form-input id="exampleInput1"
                        type="email"
                        v-model="form.email"
                        required
                        placeholder="Enter email">
                  </b-form-input>
                </b-form-group>
                <b-form-group id="exampleInputGroup1"
                    label=""
                    label-for="exampleInput1"
                    description="">
                  <b-form-input id="exampleInput1"
                        type="password"
                        v-model="form.password"
                        required
                        placeholder="Password">
                  </b-form-input>
                </b-form-group>
                <b-button @click="onSubmit" class="btn-blue" size="lg" variant="primary">Login</b-button><br><br>
                
                <!-- <b-button to="/signup" class="btn-blue" size="lg" variant="primary">Sign Up</b-button> -->
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email:'',
        password:''
      }
    }
  },
  methods: {
    async onSubmit() {
      console.log('submitted');

      var credentials = {
        email: this.form.email,
        password: this.form.password
      };

      const result = await this.$store.dispatch('login',credentials);

      console.log('got result', result);

      if(result.status!="success") {
        this.$toasted.show("Uh Oh, that's not right!");
      } else {
        this.$toasted.show('Login Successful',{type:'success'});
        this.$router.push('/dashboard');  
      }

      
    }
  },
  created: function() {

    var user = this.$store.getters.user;

    if(user.is_logged_in) {
      this.$router.replace('/dashboard');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-col {
  display: none;
}
.logo-mobile-container {
  background-color: #262f3c;
}
#login {
  height:100vh;
  display: flex;
  background-color: #77bf43 !important;
  align-items: center;
}

#login_wrapper {
  width:100%;
  
}

#the_form {
  padding: 30px 10px;
  width: 100%;
  align-self: center;
}
#art {
  background-image: url('../../static/loginbg.jpg');
  background-size: cover;
  background-position: center center;
  height: 470px;
}

#hero {
  max-width: 900px;
}

.cta {
  padding: 30px
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.qds-logo {
  display: flex;
  align-items: center;
}
.qds-logo a {
  display: inline-block;
}

.bg-green {
  background-color: #77bf43 !important;
}

@media screen and (min-width:1024px) {
  .logo-col {
    display:inline-block;
  }
  #hero .hero-col {
    padding:0;
  }

  #the_form {
  padding: 30px 60px;
  }
  .hide-on-desktop {
    display:none;
  }
  #login {
    height:100vh;
    display: flex;
    align-items: center;
    background-color: #c6c6c6 !important;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Login.vue